import { useEffect, useState } from "react";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import Download from "../../../shared/download";
import {
  OnboardingStep1ClassName,
  OnboardingStep2ClassName,
  OnboardingStep4ClassName,
  OnboardingStep6ClassName,
  OnboardingStep7ClassName,
  OnboardingStep8ClassName,
  OnboardingStep9ClassName,
  OnboardingStep10ClassName
} from "./ducks/reducer";
import ScenesWithoutDays from "./scenes-without-days";
import FilmanizeCheckbox from "../../../shared/filmanize-checkbox";
import Day from "./day";
import { getSceneItemStyleFromTimeOfDay } from "./scene";

const DaysList = ({
  hasDayOrder,
  days,
  filmId,
  updateSceneOrder,
  addShootingDay,
  deleteShootingDay,
  updateDayOrder,
  onAddScenesShootingOrderDays,
  smartScenesShootingOrderByDay,
  progress,
  download,
  clearPdf,
  onDownloadFile,
  onDeleteAllShootingDays,
  onResetSceneShootDays,
  readOnly,
  scenesWithoutDays,
  hasDates,
  toggleSelectionInGroup,
  multiSelectTo,
  toggleSelection,
  selectedSceneIds,
  draggingSceneId,
  setDraggingSceneId,
  unselectAll,
  truncateSummaries,
  colorCodeScenes,
  updateTruncateSummaries,
  updateColorCodeScenes
}) => {

  const [truncateSummary, setTruncateSummary] = useState<boolean>(false);
  const [colorCode, setColorCode] = useState<boolean>(false);
  const [showColorTooltip, setShowColorTooltip] = useState<boolean>(false);

  useEffect(() => {
    if (truncateSummaries) {
      setTruncateSummary(truncateSummaries);
    }
    if (colorCodeScenes) {
      setColorCode(colorCodeScenes);
    }
  }, [truncateSummaries, colorCodeScenes]);

  const onSetTruncateSummary = (value: boolean) => {
    setTruncateSummary(value);
    updateTruncateSummaries(value)
  };

  const onSetColorCode = (value: boolean) => {
    setColorCode(value);
    updateColorCodeScenes(value);
  };

  const onDragStart = (start) => {
    const id = start.draggableId;
    const selected = selectedSceneIds.find((sceneId) => sceneId === id);

    // if dragging an item that is not selected - unselect all items
    if (!selected) {
      unselectAll();
    }

    setDraggingSceneId(start.draggableId);
  };

  const onDragEnd = (result) => {
    setDraggingSceneId(null);

    // dropped outside the list
    if (!result.destination) {
      return;
    }

    if (result.type == "scene") {
      updateSceneOrder(
        result.source.index,
        result.destination.index,
        result.source.droppableId,
        result.destination.droppableId
      );
    } else if (result.type == "day") {
      updateDayOrder(result.source.index, result.destination.index);
    }
  };

  return (
    <>
      {!readOnly && <div className="buttons mt-2">
        <button
          type="submit"
          className={`button ${OnboardingStep1ClassName}`}
          onClick={() => smartScenesShootingOrderByDay()}
        >
          Smart Days
        </button>
        <button
          type="submit"
          className={`button ${OnboardingStep6ClassName}`}
          onClick={() => onDeleteAllShootingDays()}
        >
          Delete All
        </button>

        <button
          type="submit"
          className={`button ${OnboardingStep7ClassName}`}
          onClick={() => onResetSceneShootDays()}
        >
          Reset Scene Shoot Days
        </button>
        <div className={OnboardingStep8ClassName}>
          <FilmanizeCheckbox label="Compact view" checked={truncateSummary} onChange={onSetTruncateSummary} />
        </div>
        <div className={OnboardingStep9ClassName} style={{ position: 'relative', display: 'inline-block' }}>
          <div
            onMouseEnter={() => setShowColorTooltip(true)}
            onMouseLeave={() => setShowColorTooltip(false)}
          >
            <FilmanizeCheckbox label="Color code scenes" checked={colorCode} onChange={onSetColorCode} className={`ml-1`} />
            {showColorTooltip && colorCode && (
              <div style={{
                position: 'absolute',
                top: '100%',
                left: 0,
                marginTop: '5px',
                backgroundColor: 'white',
                border: '1px solid #ccc',
                borderRadius: '4px',
                padding: '10px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                zIndex: 1000,
                minWidth: '200px',
                color: '#040f21'
              }}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div style={{
                      width: '20px',
                      height: '20px',
                      border: '1px solid black',
                      backgroundColor: getSceneItemStyleFromTimeOfDay(1, "Int.").backgroundColor,
                      marginRight: '8px'
                    }}></div>
                    <span style={{ color: '#040f21' }}>Int. Day</span>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div style={{
                      width: '20px',
                      height: '20px',
                      border: '1px solid black',
                      backgroundColor: getSceneItemStyleFromTimeOfDay(1, "Ext.").backgroundColor,
                      marginRight: '8px'
                    }}></div>
                    <span style={{ color: '#040f21' }}>Ext. Day</span>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div style={{
                      width: '20px',
                      height: '20px',
                      border: '1px solid black',
                      backgroundColor: getSceneItemStyleFromTimeOfDay(6, "Int.").backgroundColor,
                      marginRight: '8px'
                    }}></div>
                    <span style={{ color: '#040f21' }}>Int. Morning</span>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div style={{
                      width: '20px',
                      height: '20px',
                      border: '1px solid black',
                      backgroundColor: getSceneItemStyleFromTimeOfDay(6, "Ext.").backgroundColor,
                      marginRight: '8px'
                    }}></div>
                    <span style={{ color: '#040f21' }}>Ext. Morning</span>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div style={{
                      width: '20px',
                      height: '20px',
                      border: '1px solid black',
                      backgroundColor: getSceneItemStyleFromTimeOfDay(8, "Int.").backgroundColor,
                      marginRight: '8px'
                    }}></div>
                    <span style={{ color: '#040f21' }}>Int. Afternoon</span>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div style={{
                      width: '20px',
                      height: '20px',
                      border: '1px solid black',
                      backgroundColor: getSceneItemStyleFromTimeOfDay(8, "Ext.").backgroundColor,
                      marginRight: '8px'
                    }}></div>
                    <span style={{ color: '#040f21' }}>Ext. Afternoon</span>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div style={{
                      width: '20px',
                      height: '20px',
                      border: '1px solid black',
                      backgroundColor: getSceneItemStyleFromTimeOfDay(4, "Int.").backgroundColor,
                      marginRight: '8px'
                    }}></div>
                    <span>Int. Sunrise</span>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div style={{
                      width: '20px',
                      height: '20px',
                      border: '1px solid black',
                      backgroundColor: getSceneItemStyleFromTimeOfDay(4, "Ext.").backgroundColor,
                      marginRight: '8px'
                    }}></div>
                    <span>Ext. Sunrise</span>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div style={{
                      width: '20px',
                      height: '20px',
                      border: '1px solid black',
                      backgroundColor: getSceneItemStyleFromTimeOfDay(5, "Int.").backgroundColor,
                      marginRight: '8px'
                    }}></div>
                    <span style={{ color: '#040f21' }}>Int. Sunset</span>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div style={{
                      width: '20px',
                      height: '20px',
                      border: '1px solid black',
                      backgroundColor: getSceneItemStyleFromTimeOfDay(5, "Ext.").backgroundColor,
                      marginRight: '8px'
                    }}></div>
                    <span style={{ color: '#040f21' }}>Ext. Sunset</span>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div style={{
                      width: '20px',
                      height: '20px',
                      border: '1px solid black',
                      backgroundColor: getSceneItemStyleFromTimeOfDay(2, "Int.").backgroundColor,
                      marginRight: '8px'
                    }}></div>
                    <span style={{ color: '#040f21' }}>Int. Night</span>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div style={{
                      width: '20px',
                      height: '20px',
                      border: '1px solid black',
                      backgroundColor: getSceneItemStyleFromTimeOfDay(2, "Ext.").backgroundColor,
                      marginRight: '8px'
                    }}></div>
                    <span style={{ color: '#040f21' }}>Ext. Night</span>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>}
      <DragDropContext onDragEnd={onDragEnd} onDragStart={onDragStart}>
        <Droppable droppableId="droppable" type="day">
          {(provided, snapshot) => (
            <div className="columns">
              <div className="column">
                <table
                  className={`table no-last-border ${OnboardingStep2ClassName}`}
                  {...provided.droppableProps}
                  ref={provided.innerRef}>
                  <thead>
                    <tr>
                      <th>Number</th>
                      <th>Scene Setting</th>
                      <th>Location</th>
                      <th>Int/Ext</th>
                      <th>Day/Night</th>
                      <th>Summary</th>
                      <th>Pages</th>
                      <th>Shoot Days</th>
                      <th>Shoot Duration</th>
                      <th>Characters</th>
                      <th>Script Day</th>
                    </tr>
                  </thead>

                  {(days || []).map((day, index) => (
                    <Day
                      filmId={filmId}
                      index={index}
                      toggleSelection={toggleSelection}
                      toggleSelectionInGroup={toggleSelectionInGroup}
                      multiSelectTo={multiSelectTo}
                      readOnly={readOnly}
                      day={day}
                      truncateSummary={truncateSummary}
                      colorCode={colorCode}
                      deleteShootingDay={deleteShootingDay}
                      selectedSceneIds={selectedSceneIds}
                      draggingSceneId={draggingSceneId}
                    />
                  ))}
                </table>
              </div>
              <div className="column is-narrow">{!readOnly &&
                <ScenesWithoutDays
                  scenes={scenesWithoutDays}
                  toggleSelection={toggleSelection}
                  toggleSelectionInGroup={toggleSelectionInGroup}
                  multiSelectTo={multiSelectTo}
                  selectedSceneIds={selectedSceneIds}
                  draggingSceneId={draggingSceneId}
                  colorCode={colorCode} />}</div>
            </div>
          )}
        </Droppable>
      </DragDropContext>
      <div className="buttons sticky-buttons">

        {!readOnly && <> <button
          type="submit"
          className={`button ${OnboardingStep4ClassName}`}
          onClick={() => addShootingDay()}
        >
          Add Day
        </button>
          <button
            type="submit"
            className={`button ${OnboardingStep10ClassName}`}
            onClick={() => onAddScenesShootingOrderDays(days)}
          >
            Save
          </button>
        </>}

        <Download
          progress={progress}
          clearPdf={clearPdf}
          download={download}
          downloadFile={onDownloadFile}
        ></Download>


      </div>
    </>
  );
};

export default DaysList;
